export const SET_SEND_MONEY_USER_INFO = 'SET_SEND_MONEY_USER_INFO';
export const SET_LOADING_STATUS = 'SET_LOADING_STATUS';
export const SET_PHONE_NUMBER = 'SET_PHONE_NUMBER';
export const SET_VALID_SALES_CODE = 'SET_VALID_SALES_CODE';
export const SET_OOM_FLOW_ELIGIBILITY = 'SET_OOM_FLOW_ELIGIBILITY';
export const SET_QRIS_USER_INFO = 'SET_QRIS_USER_INFO';
export const SET_QRIS_BLUE_BOX_FIRST_DATE = 'SET_QRIS_BLUE_BOX_FIRST_DATE';
export const SET_HAS_PIN = 'SET_HAS_PIN';
